import { render, staticRenderFns } from "./DeactivateUser.vue?vue&type=template&id=2ac4ffe2&lang=pug"
import script from "./DeactivateUser.vue?vue&type=script&lang=js"
export * from "./DeactivateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports